import { PagedResultWithPager } from '@extrahorizon/javascript-sdk';
import { useQuery } from '@tanstack/react-query';
import { useAppContext } from 'context/hooks';
import { PriorityKeys } from 'models/rules';
import { WorklistData, WorklistStatus } from 'models/worklist';
import { API_FUNCTIONS, queryKeys, RULES_ENDPOINTS, sdk } from 'utils/query';
import { getPriorityInfo } from 'utils/worklist';

export interface GetWorkListRecordsTotalProps {
  visibleGroupsIds?: string[];
  priority?: PriorityKeys;
  status?: WorklistStatus;
}

const getWorklistRecordsTotal = async ({
  visibleGroupsIds,
  priority,
  status = WorklistStatus.Unread,
}: GetWorkListRecordsTotalProps) => {
  if (!visibleGroupsIds || !priority) return 0;

  let rql = `limit=1&sort=-timestamp&priorities=${getPriorityInfo(priority).filter}&status=${status}`;

  const recipientGroupIds = visibleGroupsIds.map((id) => `recipientGroupIds=${id}`).join('&');
  rql += `&${recipientGroupIds}`;

  const result = await sdk.tasks.api.get<PagedResultWithPager<WorklistData>>(
    API_FUNCTIONS.monitoring,
    `${RULES_ENDPOINTS.monitoringNotifications}?${rql}`,
    {},
  );

  return result.page.total || 0;
};

export const useGetWorklistRecordsTotal = (variables: GetWorkListRecordsTotalProps) => {
  const { visibleGroupsIds } = useAppContext();
  return useQuery({
    queryKey: [queryKeys.totalAlert, variables.priority],
    queryFn: () => getWorklistRecordsTotal({ ...variables, visibleGroupsIds }),
    enabled: !!visibleGroupsIds,
  });
};
